import { useMutation } from "@tanstack/react-query";
import { uploadMedia, deleteMedia } from "./media.service";

export const useUploadMediaMutation = () => {
  return useMutation({
    mutationFn: uploadMedia,
  });
};

export const useDeleteMediaMutation = () => {
  return useMutation({
    mutationFn: deleteMedia,
  });
};